{
 "title": {
  "x": 238,
  "y": 437,
  "w": 464,
  "h": 50,
  "lane": {
   "x": 230,
   "y": 432,
   "w": 480,
   "h": 60
  }
 },
 "adult": {
  "x": 128,
  "y": 573,
  "w": 266,
  "h": 31,
  "lane": {
   "x": 124,
   "y": 556,
   "w": 526,
   "h": 70
  }
 },
 "ident": {
  "x": 129,
  "y": 688,
  "w": 232,
  "h": 30,
  "lane": {
   "x": 124,
   "y": 676,
   "w": 396,
   "h": 58
  }
 },
 "woman": {
  "x": 174,
  "y": 772,
  "w": 110,
  "h": 23,
  "lane": {
   "x": 108,
   "y": 746,
   "w": 241,
   "h": 76
  }
 },
 "man": {
  "x": 440,
  "y": 773,
  "w": 62,
  "h": 22,
  "lane": {
   "x": 359,
   "y": 746,
   "w": 224,
   "h": 76
  }
 },
 "nb": {
  "x": 631,
  "y": 772,
  "w": 169,
  "h": 23,
  "lane": {
   "x": 594,
   "y": 746,
   "w": 240,
   "h": 76
  }
 },
 "band": {
  "x": 129,
  "y": 895,
  "w": 264,
  "h": 29,
  "lane": {
   "x": 124,
   "y": 882,
   "w": 396,
   "h": 58
  }
 },
 "b1": {
  "x": 158,
  "y": 978,
  "w": 72,
  "h": 23,
  "lane": {
   "x": 106,
   "y": 950,
   "w": 174,
   "h": 77
  }
 },
 "b2": {
  "x": 343,
  "y": 977,
  "w": 74,
  "h": 24,
  "lane": {
   "x": 291,
   "y": 950,
   "w": 174,
   "h": 77
  }
 },
 "b3": {
  "x": 527,
  "y": 977,
  "w": 75,
  "h": 24,
  "lane": {
   "x": 477,
   "y": 950,
   "w": 174,
   "h": 77
  }
 },
 "b4": {
  "x": 728,
  "y": 977,
  "w": 44,
  "h": 24,
  "lane": {
   "x": 663,
   "y": 950,
   "w": 173,
   "h": 77
  }
 },
 "consent": {
  "x": 130,
  "y": 1117,
  "w": 471,
  "h": 36,
  "lane": {
   "x": 124,
   "y": 1100,
   "w": 526,
   "h": 70
  }
 },
 "continue": {
  "x": 377,
  "y": 1247,
  "w": 187,
  "h": 28,
  "lane": {
   "x": 300,
   "y": 1232,
   "w": 340,
   "h": 60
  }
 }
}